import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-equipment-add',
  templateUrl: './project-equipment-add.component.html',
  styleUrls: ['./project-equipment-add.component.css']
})
export class ProjectEquipmentAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
